import { Component } from "react";
import PropTypes from "prop-types";
import "./PassengersFieldset.scss";
import NumberInput from "app/pages/.shared/NumberInput";
import { FormattedMessage } from "react-intl";
import AlertMessage from "app/pages/.shared/AlertMessage";
import { PASSENGER_TYPE } from "app/constants";
import DateSelectorInput from "app/pages/.shared/DateSelector/DateSelectorInput";

const checkMinCount = value => {
	return value > 0;
};

class PassengersFieldset extends Component {
	constructor() {
		super();
		this.onChildrenCountChange = this.onChildrenCountChange.bind(this);
		this.onInfantCountChange = this.onInfantCountChange.bind(this);
	}

	onChildrenCountChange(value) {
		if (value > this.props.childrenField.value) {
			this.props.childrenBirthdates.addField({
				day: undefined,
				month: undefined,
				year: undefined,
			});
		} else {
			this.props.childrenBirthdates.removeField();
		}
		this.props.onChildrenSelect(Number(value));
	}

	onInfantCountChange(value) {
		if (value > this.props.infantsField.value) {
			this.props.infantsBirthdates.addField({
				day: undefined,
				month: undefined,
				year: undefined,
			});
		} else {
			this.props.infantsBirthdates.removeField();
		}
		this.props.onInfantsSelect(Number(value));
	}

	render() {
		const {
			adultsField,
			childrenField,
			infantsField,
			childrenBirthdates,
			infantsBirthdates,
			adultOnly,
			isChildrenAgeRequired,
			onAdultsSelect,
			onChildrenSelect,
			onInfantsSelect,
			onChildrenAgeChange,
			onInfantsAgeChange,
		} = this.props;

		return (
			<div className="passengers-fieldset">
				{adultOnly && (
					<AlertMessage
						message={<FormattedMessage id="search.engine.adult.only.short.warning" />}
					/>
				)}

				<div className="passengers-fieldset__item">
					<div className="passengers-fieldset__label">
						<label htmlFor="adults">
							<FormattedMessage id="search.engine.adults.label" tagName="span" />
							{isChildrenAgeRequired && (
								<FormattedMessage
									id="search.engine.adults.age.range.label"
									tagName="span"
								/>
							)}
						</label>
					</div>
					<div className="passengers-fieldset__input">
						<NumberInput
							id="adults"
							field={adultsField}
							onValueChanged={onAdultsSelect}
						/>
					</div>
				</div>

				{!adultOnly && (
					<div className="passengers-fieldset__item">
						<div className="passengers-fieldset__label">
							<label htmlFor="children">
								<FormattedMessage
									id="search.engine.children.label"
									tagName="span"
								/>
								<FormattedMessage
									id="search.engine.children.age.range.label"
									tagName="span"
									values={{ minAge: 2, maxAge: isChildrenAgeRequired ? 17 : 11 }}
								/>
							</label>
						</div>
						<div className="passengers-fieldset__input">
							<NumberInput
								id="children"
								field={childrenField}
								canDecrement={value => checkMinCount(value)}
								onValueChanged={
									isChildrenAgeRequired
										? this.onChildrenCountChange
										: onChildrenSelect
								}
							/>
						</div>
					</div>
				)}

				{!adultOnly &&
					isChildrenAgeRequired &&
					childrenBirthdates.map((childrenBirthdate, index) => {
						return (
							<div
								key={index}
								className="passengers-fieldset__item passengers-fieldset__item--birthdate"
							>
								<div className="passengers-fieldset__label">
									<label htmlFor={`children-age-${index + 1}`}>
										<FormattedMessage
											values={{ index: index + 1 }}
											id="payment.passengers.child"
											tagName="span"
										/>
									</label>
								</div>
								<div className="passengers-fieldset__input">
									<DateSelectorInput
										formatMonth="2-digit"
										isChildrenAgeRequired={isChildrenAgeRequired}
										label={
											<FormattedMessage id="search.engine.birthdate.label" />
										}
										fields={childrenBirthdate}
										id={`children-age-${index + 1}`}
										name={`children-age-${index + 1}`}
										type={PASSENGER_TYPE.CHILD}
										onChange={value => {
											onChildrenAgeChange(value, index);
										}}
									/>
								</div>
							</div>
						);
					})}

				{!adultOnly && (
					<div className="passengers-fieldset__item">
						<div className="passengers-fieldset__label">
							<label htmlFor="infants">
								<FormattedMessage id="search.engine.infants.label" tagName="span" />
								<FormattedMessage
									id="search.engine.infants.age.range.label"
									tagName="span"
								/>
							</label>
						</div>
						<div className="passengers-fieldset__input">
							<NumberInput
								id="infants"
								field={infantsField}
								canDecrement={value => checkMinCount(value)}
								onValueChanged={
									isChildrenAgeRequired
										? this.onInfantCountChange
										: onInfantsSelect
								}
							/>
						</div>
					</div>
				)}

				{!adultOnly &&
					isChildrenAgeRequired &&
					infantsBirthdates.map((infantBirthdate, index) => {
						return (
							<div
								key={index}
								className="passengers-fieldset__item passengers-fieldset__item--birthdate"
							>
								<div className="passengers-fieldset__label">
									<label htmlFor={`infant-age-${index + 1}`}>
										<FormattedMessage
											values={{ index: index + 1 }}
											tagName="span"
											id="payment.passengers.infant"
										/>
									</label>
								</div>
								<div className="passengers-fieldset__input">
									<DateSelectorInput
										formatMonth="2-digit"
										isChildrenAgeRequired={isChildrenAgeRequired}
										label={
											<FormattedMessage id="search.engine.birthdate.label" />
										}
										fields={infantBirthdate}
										id={`infant-age-${index + 1}`}
										name={`infant-age-${index + 1}`}
										type={PASSENGER_TYPE.INFANT}
										onChange={value => {
											onInfantsAgeChange(value, index);
										}}
									/>
								</div>
							</div>
						);
					})}
			</div>
		);
	}
}

PassengersFieldset.defaultProps = {
	adultsField: {},
	childrenField: {},
	infantsField: {},
	childrenBirthdates: [],
	infantsBirthdates: [],
	adultOnly: false,
	isChildrenAgeRequired: false,
};

PassengersFieldset.propTypes = {
	adultsField: PropTypes.object,
	childrenField: PropTypes.object,
	infantsField: PropTypes.object,
	childrenBirthdates: PropTypes.array,
	infantsBirthdates: PropTypes.array,
	adultOnly: PropTypes.bool,
	isChildrenAgeRequired: PropTypes.bool,
	onAdultsSelect: PropTypes.func,
	onChildrenSelect: PropTypes.func,
	onInfantsSelect: PropTypes.func,
	onChildrenAgeChange: PropTypes.func,
	onInfantsAgeChange: PropTypes.func,
};

export default PassengersFieldset;
